import { useEffect } from "react";

/**
 * Opens a Server-Sent Events (SSE) stream to /api/events for the active
 * user+shop. Any push from the backend fires the existing
 * `kirana:revalidate` event, so every list page already wired to
 * `useRevalidate` instantly refetches when a sibling device mutates data.
 *
 * The connection auto-reconnects (built into EventSource). Token is passed
 * as a query param because EventSource cannot set Authorization headers.
 */
export default function useLiveSync(enabled) {
  useEffect(() => {
    if (!enabled) return;
    const token = localStorage.getItem("token");
    if (!token) return;
    const base = process.env.REACT_APP_BACKEND_URL;
    const url = `${base}/api/events?token=${encodeURIComponent(token)}`;
    let es;
    try {
      es = new EventSource(url);
    } catch (_e) {
      return;
    }
    const onMessage = () => {
      window.dispatchEvent(new CustomEvent("kirana:revalidate"));
    };
    es.addEventListener("data_changed", onMessage);
    es.onmessage = onMessage;
    es.onerror = () => {
      // EventSource retries automatically; nothing to do.
    };
    return () => {
      try { es.close(); } catch (_e) { /* noop */ }
    };
  }, [enabled]);
}
